import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestUploadInlineImage(file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.request({
        method: "post",
        url: `${getApiUrl()}/attachment/inline`,
        data: formData,
        withCredentials: true,
        crossorigin: true,
    });
}
